import React from 'react'
import { SvgIcon } from '@material-ui/core'

function ProfileIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Vector'
        d='M16.0382 13.272C17.3184 13.272 18.3562 14.3099 18.3562 15.5901L18.355 16.7465C18.514 19.5846 16.328 21 12.2744 21C8.23382 21 6 19.6032 6 16.787V15.5901C6 14.3099 7.03781 13.272 8.31801 13.272H16.0382ZM16.0382 14.8174H12.1781H8.31801C7.89128 14.8174 7.54534 15.1633 7.54534 15.5901V16.787C7.54534 18.558 8.97933 19.4547 12.2744 19.4547C15.5563 19.4547 16.9098 18.5783 16.8109 16.7897V15.5901C16.8109 15.1633 16.4649 14.8174 16.0382 14.8174ZM12.1814 4C14.3154 4 16.0453 5.72996 16.0453 7.86398C16.0453 9.99799 14.3154 11.728 12.1814 11.728C10.0473 11.728 8.31739 9.99799 8.31739 7.86398C8.31739 5.72996 10.0473 4 12.1814 4ZM12.1814 5.54534C10.9008 5.54534 9.86273 6.58343 9.86273 7.86398C9.86273 9.14453 10.9008 10.1826 12.1814 10.1826C13.4619 10.1826 14.5 9.14453 14.5 7.86398C14.5 6.58343 13.4619 5.54534 12.1814 5.54534Z'
      />
    </SvgIcon>
  )
}

export default ProfileIcon
